import { render, staticRenderFns } from "./accompanyingPassport.vue?vue&type=template&id=0a20f61b&scoped=true&"
import script from "./accompanyingPassport.vue?vue&type=script&lang=js&"
export * from "./accompanyingPassport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a20f61b",
  null
  
)

export default component.exports